import { render } from "./AppDownlord.vue?vue&type=template&id=59d55904&scoped=true"
import script from "./AppDownlord.vue?vue&type=script&lang=js"
export * from "./AppDownlord.vue?vue&type=script&lang=js"

import "./AppDownlord.vue?vue&type=style&index=0&id=59d55904&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59d55904"]])

export default __exports__